var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"py-8 py-sm-16 px-0"},[_c('v-row',{staticClass:"text-center mb-1",attrs:{"justify":"center"}},[_c('v-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('div',{staticClass:"white--text font-weight-light text-h3 text-sm-h2 text-md-h1"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }